import type { ColumnDef } from '../data/types';
import { WORLD_TOP } from '../data/tuning';
import { aabbOverlap, createAabb, type Aabb } from './collision';

/**
 * A gap column is two solid pieces (GDD §5.4): the bottom one from y 0 to the gap and the top one from
 * the gap to the top of the world. The collision geometry is the same in every world; only the skin
 * changes.
 */
export function columnPieces(column: Pick<ColumnDef, 'x' | 'gapY' | 'gapH'>, width: number): readonly [Aabb, Aabb] {
  const gapBottom = column.gapY - column.gapH / 2;
  const gapTop = column.gapY + column.gapH / 2;
  return [
    createAabb(column.x, gapBottom / 2, width, gapBottom),
    createAabb(column.x, (gapTop + WORLD_TOP) / 2, width, WORLD_TOP - gapTop),
  ];
}

/** Touching either piece counts (GDD §5.2). */
export function collidesWithColumn(player: Aabb, pieces: readonly Aabb[]): boolean {
  return pieces.some((piece) => aabbOverlap(player, piece));
}

/** The tail of the plane is past the right edge of the column: the column is passed. */
export function hasPassed(player: Aabb, column: Pick<ColumnDef, 'x'>, width: number): boolean {
  return player.x - player.halfW > column.x + width / 2;
}
